import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { isBlank, isPresent } from '@seedlang/utils';

const Wrapper = styled.a`
  display: inline-block;
  .fragment {
    display: inline;
  }
  .fragment:not(:first-child) {
    margin: 0 0 0 5px;
  }
  .object {
    font-weight: bold;
  }
`;

@observer
class NotificationMessage extends React.Component {

  render() {
    return (
      <Wrapper
        href={this.props.notification.notificationLink}
      >
        {
          isPresent(this.props.notification.leagueLevel) &&
            <span className='fragment'>
              {
                this.props.notification.action === 'demoted' ? (
                  <>
                    {`You have been demoted to the ${this.props.notification.leagueLevel.name}.  Keep learning to climb back up!`}
                  </>
                ) : this.props.notification.action === 'promoted' ? (
                  <>
                    {`Well done! You have been promoted to the ${this.props.notification.leagueLevel.name}.`}
                  </>
                ) : (
                  <>
                    {`You have been added to the ${this.props.notification.leagueLevel.name}. Good luck!`}
                  </>
                )
              }
            </span>
        }
        {
          isBlank(this.props.notification.leagueLevel) &&
            <>
              {
                this.props.notification.primarySender &&
                  <span className='fragment'>
                    {this.props.notification.primarySender.name ? this.props.notification.primarySender.name.trim() : 'Someone'}
                  </span>
              }
              {
                this.props.notification.additionalUsers &&
                  <span className='fragment'>
                    {this.props.notification.additionalUsers}
                  </span>
              }
              <span className='fragment'>
                {this.props.notification.notificationText}
              </span>
              {
                this.props.notification.linkText &&
                  <div
                    className='fragment object link'
                  >
                    {this.props.notification.linkText}
                  </div>
              }
              {
                this.props.notification.notificationObject &&
                  <div
                    className='fragment object'
                  >
                    {this.props.notification.notificationObject}
                  </div>
              }
              .
            </>
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(NotificationMessage);
